<template>
  <div class="research_1">
    <v-container>
      <v-row class="mt-4" justify="center">
        <v-col cols="10" xl="8">
          <div class="heading text-h6 text-sm-h4 font-weight-bold pl-4">
            生活習慣病危険因子検出および注意喚起システムの開発
          </div>
        </v-col>
        <v-col cols="9" xl="7">
          <div>
            <div>令和3年度～4年度複数年研究</div>
            <div>研究代表者：松本和幸</div>
            <div>共同研究者：北研二・吉田稔・西村良太</div>
          </div>
        </v-col>
      </v-row>

      <v-row class="my-4" justify="center">
        <v-col cols="9" lg="8" xl="5">
          <a>
            <v-img @click="clickImage(require(`@/assets/research/R3_4_research_matsumoto.png`))"
            :src="require(`@/assets/research/R3_4_research_matsumoto.png`)"></v-img>
          </a>
        </v-col>
      </v-row>

      <!-- 区切り線 -->
      <v-row class="my-4" justify="center">
        <v-col cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" xl="8">
          <div class="text-h6 text-sm-h5 font-weight-bold pl-4">研究概要</div>
        </v-col>
      </v-row>
      <v-row class="my-2" justify="center">
        <v-col cols="9" xl="7">
          <div>
            本研究では，年々増加している生活習慣病に着目し，生活習慣とそれを取り巻く環境をもとに，生活習慣病の危険因子を検出し，注意喚起するシステムを開発する。本システムは，従来の健康管理アプリとは異なり，特別な機器や入力を必要とせず，闘病ブログとソーシャルメディア，音声対話システムを用いて生活習慣と周囲の環境の認識と生活習慣病の危険因子を検出するものである。利用者に対し，多くの情報入力やセンサの装着などといった特別な操作や準備を要求しない注意喚起システムであり，幅広い層の人々に受け入れられるシステムを目指している。
          </div>
        </v-col>
      </v-row>

      <v-row class="my-4" justify="center">
        <v-col cols="9" lg="8" xl="5">
          <a>
            <v-img @click="clickImage(require(`@/assets/research/R3_4_research_matsumoto2.png`))"
            :src="require(`@/assets/research/R3_4_research_matsumoto2.png`)"></v-img>
          </a>
        </v-col>
      </v-row>

      <!-- 区切り線 -->
      <v-row class="my-4" justify="center">
        <v-col cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" xl="8">
          <div class="text-h6 text-sm-h5 font-weight-bold pl-4">研究目的</div>
        </v-col>
      </v-row>
      <v-row class="my-2" justify="center">
        <v-col cols="9" xl="7">
          <div>
            生活習慣病の患者が日常的に記録している闘病ブログから，生活習慣病の症状や日々の健康状態および生活行動パターンに関する記述をテキストマイニング技術および数値パターンマイニング，人工知能技術を組合わせることで抽出し，ソーシャルメディアおよび音声対話システムの利用者のための具体的な方策を言語情報および数値により提示するシステムの開発を目的とする。
          </div>
        </v-col>
      </v-row>

      <!-- 区切り線 -->
      <v-row class="my-4" justify="center">
        <v-col cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" xl="8">
          <div class="text-h6 text-sm-h5 font-weight-bold pl-4">事業内容</div>
        </v-col>
      </v-row>
      <v-row class="my-2" justify="center">
        <v-col cols="9" xl="7">
          <div>
            生活習慣病の患者が日常的に記録している闘病ブログから生活習慣病の症状や日々の健康状態の状況を人工知能技術を用いて抽出し，ソーシャルメディアの利用者の普段の生活習慣との照合を行うことで，生活習慣病の注意喚起を行うシステムを提案する。
            具体的には，以下の3つについて，手法を提案する。

            <ol class="list mt-2">
              <li>
                投稿内容の類似性から，闘病者とソーシャルメディアユーザの生活習慣の類似性を計算
              </li>
              <li>
                闘病者の生活習慣病の症状の悪化と，それに関連する要因（危険因子）を検出
              </li>
              <li>
                ソーシャルメディアユーザの普段の発言内容から行動パターンを推測し，生活習慣病の危険因子が含まれているかを検出
              </li>
            </ol>

            <div class="mt-2">
              上記の3つの手法を実現し，生活習慣病の発症や悪化を未然に防ぐための注意喚起を行うシステムを開発する。最終的には，音声対話可能な簡易なコミュニケーションロボットに本技術を実装することにより，音声対話内容から行動パターンを推測する仕組みに拡張することで，幅広い層（高齢者や未就学児など，PCやスマートフォン，ソーシャルメディアを利用しない人々）にも対応させる。
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- 区切り線 -->
      <v-row class="my-4" justify="center">
        <v-col cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" xl="8">
          <div class="text-h6 text-sm-h5 font-weight-bold pl-4">
            研究プロセス
          </div>
        </v-col>
      </v-row>
      <v-row class="my-2" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <ol class="list">
              <li>
                データの収集・整理（闘病ブログ、ソーシャルメディア）
                <ul>
                  <li>ノイズ除去（広告、RTなど）</li>
                  <li>
                    キーワードへのタグ付けおよび危険因子ラベル付与（徳島大学病院のアドバイスを受ける予定）
                  </li>
                </ul>
              </li>
              <li>
                生活習慣パターン推定モデルの構築
                <ul>
                  <li>
                    SNS投稿内容から睡眠時間、通勤時間、食事時間の時系列分析による推定
                  </li>
                </ul>
              </li>
              <li>
                危険因子検出モデルおよび注意喚起システムの構築
                <ul>
                  <li>数値マイニングによる血糖値情報などから因果関係を検出</li>
                  <li>感情分析技術を用いて危険因子の検出予測と注意喚起</li>
                </ul>
              </li>
              <li>
                画像・リンクアドレス解析による欠損情報の補完技術
                <ul>
                  <li>画像解析による食事内容・精神状態判定</li>
                  <li>リンクアドレス解析による興味情報判定</li>
                </ul>
              </li>
              <li>
                音声対話による発話内容からの生活習慣パターン推定手法の構築
                <ul>
                  <li>音声対話履歴に対する生活習慣パターン推定への拡張</li>
                  <li>
                    音声対話ロボットを用いた評価（被験者募集は徳島大学医学部の協力を得る）
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </v-col>
      </v-row>

      <!-- 区切り線 -->
      <v-row class="my-4" justify="center">
        <v-col cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" xl="8">
          <div class="text-h6 text-sm-h5 font-weight-bold pl-4">
            業績
          </div>
        </v-col>
      </v-row>
      <v-row class="my-2" justify="center">
        <v-col cols="9" xl="7">
          <div>
            <ol class="list">
              <li>
                糖尿病患者のブログに記述された生活習慣の抽出
                <ul>
                  <li>宮下 翼, 松本 和幸, 吉田 稔, 西村 良太, 北 研二</li>
                  <li>電気学会論文誌, Vol.142, No.10, 1144-1155, 2022年<br>(DOI: 10.1541/ieejeiss.142.1144, CiNii: 1390293633437552768)</li>
                </ul>
              </li>
              <li>
                Extraction of keywords from disease-fighting blogs by fine-tuning the T5 model
                <ul>
                  <li>Shohei Noguchi, Kazuyuki Matsumoto, Minoru Yoshida, Ryota Nishimura and Kenji Kita</li>
                  <li>2022 6th International Conference on Natural Language Processing and Information Retrieval, Dec. 2022</li>
                </ul>
              </li>
              <li>
                Emotion and personality estimation of utterances in a dialogue model reflecting personality
                <ul>
                  <li>Daiki Mori, Kazuyuki Matsumoto, Manabu Sasayama, Minoru Yoshida and Kenji Kita</li>
                  <li>Proceedings of 4th International Conference on Technological Competency as Caring in Nursing and Health Sciences 2022, 105, Online, Dec. 2022</li>
                </ul>
              </li>
              <li>
                Objective Analysis Techniques for Descriptive Answer Sentences in Questionnaires Using Natural Language Processing and Machine Learning
                <ul>
                  <li>Kazuyuki Matsumoto</li>
                  <li>4TH INTERNATIONAL CONFERENCE ON TECHNOLOGICAL COMPETENCY AS CARING IN NURSING AND HEALTH SCIENCES 2022, Online, Dec. 2022</li>
                </ul>
              </li>
              <li>
                Analysis of Lifestyle Habits from Weblogs of Patients with Intractable Diseases Using Deep Learning
                <ul>
                  <li>Naomichi Tabuchi, Kazuyuki Matsumoto, Minoru Yoshida, Ryota Nishimura and Kenji Kita</li>
                  <li>Proceedings of International Conference on Electrical, Computer and Energy Technologies (ICECET), Jul. 2022</li>
                </ul>
              </li>
              <li>
                Risk Analysis of Developing Lifestyle-related Diseases based on the Content of Social Networking Service Posts
                <ul>
                  <li>Naomichi Tabuchi, Kazuyuki Matsumoto, Minoru Yoshida, Ryota Nishimura and Kenji Kita</li>
                  <li>Innovation in Medicine and Healthcare, Part of the Smart Innovation, Systems and Technologies book series, Vol.308, 63-72, Jun. 2022</li>
                </ul>
              </li>
              <li>
                Lifestyle Analysis via a Corpus of Disease-Fighting Weblogs
                <ul>
                  <li>Kazuyuki Matsumoto, Ryu Mopuaa, Minoru Yoshida and Kenji Kita</li>
                  <li>Proceedings of 2021 IEEE 2nd International Conference on Pattern Recognition and Machine Learning (PRML 2021), 266-272, Chengdu, Jul. 2021</li>
                </ul>
              </li>
              <li>
                音声対話ロボットを用いた健康維持支援システムの開発
                <ul>
                  <li>早道 広峻, 松本 和幸, 吉田 稔, 西村 良太, 北 研二</li>
                  <li>HAI シンポジウム2023 講演論文集, 2023年3月</li>
                  <iframe class="youtube-16-9" 
                          src="https://www.youtube.com/embed/r1oFpb0_lNY" 
                          title="YouTube video player" 
                          frameborder="0" 
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                          allowfullscreen>
                  </iframe>
                </ul>
              </li>
              <li>
                個性を反映した対話モデルにおける発話文の感情及び性格推定
                <ul>
                  <li>森 大樹, 松本 和幸, 篠山 学, 吉田 稔, 北 研二</li>
                  <li>信学技報, 34-38, 2022年10月</li>
                </ul>
              </li>
              <li>
                インタビュー対話に基づく個性を反映した対話モデルの構築
                <ul>
                  <li>森 大樹, 松本 和幸, 篠山 学, 吉田 稔, 北 研二</li>
                  <li>令和4年度 電気・電子・情報関係学会 四国支部連合大会講演論文集, 139, 2022年9月</li>
                </ul>
              </li>
              <li>
                SNSの投稿内容に基づく生活習慣病発症リスクの分析
                <ul>
                  <li>田渕 尚道, 松本 和幸, 吉田 稔, 西村 良太, 北 研二</li>
                  <li>言語処理学会 第28回年次大会 発表論文集, 1946-1950, 2022年3月</li>
                </ul>
              </li>
              <li>
                闘病ブログコーパスからの生活習慣の抽出
                <ul>
                  <li>宮下 翼, 吉田 稔, 松本 和幸, 西村 良太, 北 研二</li>
                  <li>令和3年度 電気・電子・情報関係学会 四国支部連合大会 講演論文集, 187, 2021年9月</li>
                </ul>
              </li>
            </ol>
          </div>
        </v-col>
      </v-row>

      <!-- 区切り線 -->
      <v-row class="my-4" justify="center">
        <v-col cols="10" xl="8">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" xl="8">
          <div class="text-h6 text-sm-h5 font-weight-bold pl-4">助成</div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="9" xl="7">
          この研究は公益財団法人JKA公益財団法人JKA機械振興補助事業（研究補助）の助成を受けて行われています。
        </v-col>
      </v-row>
      <v-row class="my-4" justify="center">
        <v-col cols="5" lg="3">
          <a href="https://www.jka-cycle.jp/" target="_blank">
            <v-img :src="require(`@/assets/research/JKA_banner.svg`)"></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "R1",
  methods: {
    clickImage: function (image) {
      window.open(image);
    }
  }
}
</script>
<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
iframe.youtube-16-9 {
width: 100%;
height: auto;
aspect-ratio: 16 / 9;
}
</style>